import styled from "styled-components";
import { blueColor } from "../styled/Theme";

import { CSSProperties, MouseEventHandler, ReactNode } from "react";
import { ChildrenType } from "../../types/common";

type TagSpanPropType = {
  children: ChildrenType;
  dark?: boolean;
  error?: boolean;
  primary?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

const Wrapper = styled.section`
  width: 100%;
`;

const Header = styled.div`
  padding-bottom: 50px;
  @media (max-width: 960px) {
    width: 100%;
    text-align: center;
  }
`;

const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;

const MapWrapper = styled.div`
  width: auto;
  height: 88%;
  border: 1px solid #d0d0d0;
  border-radius: 10px;
  overflow: hidden;
  @media (max-width: 960px) {
    height: 350px;
  }
`;

const RoundedContainer = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  border-radius: 30px;
`;

const Divider = styled.div`
  height: 1px;
  margin: 10px 0;
  background-color: #0000002a;
`;

export const LeftMenuButton = styled.button`
  padding: 10px 0 10px 15px;
  background: none;
  border: none;
`;

export const TagSpan = ({
  children,
  dark = false,
  error = false,
  primary = false,
  onClick,
}: TagSpanPropType) => {
  let color: string = "green";
  if (dark) color = "#fff";
  if (error) color = "#ff0000";
  if (primary) color = "green";

  const styles = {
    color: `${color}`,
    paddingTop: "2px",
    fontSize: "12px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    textAlign: "center",
    borderRadius: "15px",
    paddingInline: "15px",
    cursor: `${onClick && "pointer"}`,
  };
  return (
    <button onClick={onClick} style={styles as CSSProperties}>
      {children}
    </button>
  );
};

export const RowWrapper = styled.section`
  width: 100%;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

export { Wrapper, Header, BtnWrapper, MapWrapper, RoundedContainer, Divider };

export const ButtonWrapper = ({
  children,
  style,
}: {
  children: ReactNode;
  style?: CSSProperties;
}) => {
  return (
    <div
      style={{
        width: 200,
        padding: 12,
        paddingTop: 0,
        paddingBottom: 0,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

/* Main container for the form */
export const AuthWrapper = styled.div`
  padding: 50px 40px;
  width: 40%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${blueColor};
  color: #ffffff;
  // border-radius: 12px;
  // box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);

  p,
  span,
  h4 {
    color: #ffffff;
  }

  // .ant-btn-primary {
  //   background-color: #ffffff;
  //   color: ${blueColor};
  //   border: none;
  //   font-weight: 600;
  //   padding: 10px 25px;
  //   border-radius: 8px;
  //   transition: 0.3s;

  //   &:hover {
  //     background-color: #e6e6e6;
  //     color: ${blueColor};
  //   }
  // }

  // .ant-alert {
  //   border-radius: 8px;
  //   margin-bottom: 10px;
  // }

  @media (max-width: 1080px) {
    width: 50%;
    padding: 40px;
  }

  @media (max-width: 960px) {
    width: 100%;
    padding: 30px;
  }
`;

/* Optional side illustration */
export const AuthSideWrapper = styled.div`
  padding: 40px;
  width: 60%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;

  img {
    display: block;
    max-width: 80%;
    height: auto;
    // border-radius: 12px 0 0 12px;
    // border-top-right-radius: 10px;
    // box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 1080px) {
    width: 50%;
  }

  @media (max-width: 960px) {
    display: none;

    // img {
    //   border-radius: 0; // remove rounding on mobile
    // }
  }
`;

export const DashboardCard = styled.div<{ backgroundColor?: string }>`
  background: ${(p) =>
    p.backgroundColor
      ? p.backgroundColor
      : "linear-gradient(145deg, #ffffff, #f8fafc)"};
  border-radius: 20px;
  padding: 26px;
  border: 1px solid #e2e8f0;
  // box-shadow:
  //   0px 10px 25px rgba(0, 0, 0, 0.06),
  //   0px 4px 12px rgba(0, 0, 0, 0.04);
  transition: all 0.35s ease;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 20px;

  &:hover {
    transform: translateY(-6px);
    // box-shadow:
    //   0px 18px 40px rgba(0, 0, 0, 0.12),
    //   0px 6px 18px rgba(0, 0, 0, 0.08);
  }
`;

export const CardIconWrap = styled.div`
  // width: 54px;
  // height: 54px;
  // border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-bottom: 14px;
  // background: rgba(0, 0, 0, 0.06);
  // backdrop-filter: blur(4px);
`;

export const CardLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #334155;
`;

export const CardValue = styled.div`
  font-size: 25px;
  font-weight: 800;
  color: #0f172a;
  margin-top: 6px;
`;

export const CardChange = styled.div<{ type: string }>`
  margin-top: 10px;
  font-size: 14px;
  font-weight: 500;
  color: ${(p) =>
    p.type === "positive"
      ? "#10b981"
      : p.type === "negative"
        ? "#ef4444"
        : "#475569"};
`;
